import { useEffect, useContext } from 'react'
import KRGlue from '@lyracom/embedded-form-glue'
import { server } from '../config/config-prod'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { CarritoContext } from '../context/CarritoContext'
import { limpiarLocalStorage } from '../resources/funciones'
import Swal from 'sweetalert2';

import {useTranslation} from 'react-i18next'

export const PagoIziPay = () => {

    const { setCompraValida, vaciarCarrito } = useContext(CarritoContext)

    const logo = "/image/logos/LOGO1_Short.png"    
    
    const location = useLocation()
    const { t, i18n } = useTranslation()

    const formToken = location?.state?.token || ""
    const detalles = location?.state?.dataDetalles || ""
    const codSolicitud = location?.state?.codigo_solicitud || ""
    const dataComprobante = location?.state?.dataComprobante || {}

    const navigate = useNavigate()

    const irCarrito = () => navigate("/carrito")

    const alertMix = Swal.mixin({
        confirmButtonColor: 'rgb(5, 47, 62)',
        confirmButtonText: t("pago_alert_btn_aceptar")
    })

    const  mensajeErrorPagoCincoIntentos = () => {
        alertMix.fire({
            title: t("pago_alert_error_titulo"),
            text: t("pago_alert_error_msg")            
        });
    }

    const mensajeErrorPago = (mensajeError) => {
        alertMix.fire({
            title: t("pago_alert_error_titulo"),
            text: `${t("pago_alert_error_msg")} ${mensajeError}`            
        });
    }

    const mensajeErrorConfirmacionPago = () => {
        alertMix.fire({
            text: t("pago_alert_error_msg3")
        })
    }

    useEffect(() => {

        const script1 = document.createElement('script');
        script1.async = true;
        script1.defer = true;
        script1.src = 'https://static.micuentaweb.pe/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js';
        script1.setAttribute('kr-public-key', server.publicKeyIziPay);
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.async = true;
        script2.defer = true;
        script2.src = 'https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic.js';
        document.head.appendChild(script2);

        const link = document.createElement('link');
        link.async = true;
        link.defer = true;
        link.rel = 'stylesheet';
        link.href = 'https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic-reset.css'
        document.head.appendChild(link);

        return () => {
            const script = document.querySelector('script[kr-public-key]')
            document.head.removeChild(script);
            // window.location.reload()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const krLanguages = {
            es:'es-PE',
            en:'en-US'
        }
        async function setupPaymentForm() {
            const endpoint = "https://static.micuentaweb.pe"
            const publicKey = server.publicKeyIziPay
            try {

                const { KR } = await KRGlue.loadLibrary(
                    endpoint,
                    publicKey
                ) 

                await KR.setFormConfig({ 
                    formToken: formToken,
                    'kr-language': krLanguages[i18n.language] 
                })

                const { result } = await KR.attachForm(
                    '#myPaymentForm'
                )


                await KR.onSubmit(async (paymentData) => {
                    console.log("Se ejecuta incluso si hay error")
                    try {                        
                        const dataPOST = {
                        SolCod: codSolicitud,
                        comprobante: dataComprobante,
                        izi: {
                            ...paymentData,
                            validar: true
                            }                        
                        }
                        const response = await axios.post(server.serverUrl + "/api/solicitud/FinalizarSolicitud", dataPOST)

                        if (response.status === 201) {
                            setCompraValida(true)
                            vaciarCarrito()
                            limpiarLocalStorage('cliente')
                            navigate("/final-compra", {
                                replace: true
                            })
                        }

                        if (response.status === 401) {
                            mensajeErrorConfirmacionPago()
                        }

                        if (response.status === 202) {
                            //me devuelve 202 en caso se haga 5 intentos de pago y todos fallidos
                            navigate("/compra", {
                                replace: true
                            })
                            mensajeErrorPagoCincoIntentos()
                        }
                        
                    } catch (error) {
                        mensajeErrorConfirmacionPago()
                    }
                    return false // Return false to prevent the redirection
                })

                await KR.onError(async (error) => {
                    try {
                        const dataPOST = {
                            SolCod: codSolicitud,
                            comprobante: dataComprobante,
                            izi: {
                                ...error,
                                validar: false
                            }
                        }
                        
                        const response = await axios.post(server.serverUrl + "/api/solicitud/FinalizarSolicitud", dataPOST)
                        
                        if (response.data.status === 0) {
                            if(response.status !== 202){
                                mensajeErrorPago(response.data.message)
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    return false
                })

                await KR.showForm(result.formId) /* show the payment form */
            } catch (error) {
                alertMix.fire({
                    title:t("pago_alert_error_pasarela")
                })

            }
        }

        if (!!formToken) {
            setupPaymentForm()
        }
        // eslint-disable-next-line
    }, [formToken])

    useEffect(() => {
        window.addEventListener('error', e => {
            if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'Script error.') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                )
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                )
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        })
    }, [])   

    return (
        <div className='vh-100 d-flex flex-column'>
            {/* Navbar de compra */}
            <nav className="navbar bg-primario position-relative">
                <div className="container contenedor-logo">
                    <Link className="navbar-brand col-4 m-1 logo-envio me-4" to="/inicio">
                        <img height={60} src={logo} alt="Logo Altos de Azpitia" />
                    </Link>                    
                </div>
            </nav>
            <div className="container flex-grow-1" >                
            {(!!formToken) ? (
                <div className="row h-100 pb-5">
                    <div className="col-md-8 d-flex flex-column" style={{textTransform:"uppercase"}}>
                        <div className='mt-4' >
                            <h3>{t("pago_cabecera1")}</h3>
                        </div>
                        <div className="floating-card bg-secundario">

                            <div> {detalles.SolNom + " " + detalles.SolApe}</div>
                            <div> {detalles.SolEmail}</div>
                            <div> {detalles.SolDire + ", " + detalles.SolCiud + ", " + detalles.SolProv + ", " + detalles.SolDep + ", " + detalles.SolPais}</div>
                            <div> {detalles.SolTel}</div>
                        </div>
                        <div className='mt-4'>
                            <h3>{t("pago_cabecera2")}</h3>
                        </div>
                        <div className='floating-card bg-secundario'>
                            <div>{dataComprobante.PagTipComp==='B'?'BOLETA':'FACTURA'}</div>
                            {dataComprobante.PagTipComp==='B' && <div>{dataComprobante.PagTipId === 'D'?'DNI':'C. Extranjería'} - {dataComprobante.PagIdNum}</div>}
                            {dataComprobante.PagTipComp==='F'&&  <div>RUC - {dataComprobante.PagRuc}</div>}
                            <div>{dataComprobante.PagTipComp==='B'?dataComprobante.PagNom +' '+dataComprobante.PagApe:dataComprobante.PagRazon}</div>
                            
                        </div>
                        <div className="mt-3 floating-card bg-cuaternario text-white">
                            {t("pago_envio_plazo")}
                        </div>

                        <div className='flex-grow-1 position-relative' style={{minHeight:"4rem"}}>
                            <button className="btn btn-primario-analogo text-center position-absolute " style={{bottom:"0"}} onClick={irCarrito}>
                                {t("pago_btn_volver")}
                            </button>
                        </div>        
                    </div>

                    <div className="col-md-4 d-flex flex-column">
                        <div className='mt-4' style={{textTransform:"uppercase"}}>
                            <h3>{t("pago_cabecera3")}</h3>
                        </div>
                        <div className="d-flex  justify-content-center">
                            <div id="myPaymentForm" className='bg-secundario floating-card p-3'>
                                <div className="kr-smart-form" kr-card-form-expanded="true" ></div>
                            </div>
                        </div>
                    </div>
                </div>
            ):(
                <div className="row">
                    <Link className="nav-link text-center mt-3" to="/compra">
                        {t("pago_envio_detalle_vacio")}
                    </Link>
                </div>
            )}
            </div>
        </div>

    )
}
